import React, {Component} from 'react';
import {SanitizeClassNames} from '../../common';

import AppointmentType from '../../api/AppointmentType';
import editIcon from '../../images/icons/IconEdit-grey.png'
import { FormLabeledItem, Input, SelectList, Button, FormDataObj, FormItemBase } from '../../components/FormUI';
import Icon from '../../components/Icon';
import AppointmentTypeService from '../../api/services/AppointmentTypeService';
import { AppointmentCategoryList } from '../../components/DataSelectList';
import { SwatchesPicker } from 'react-color';
import TimeStepper from '../../components/TimeStepper';

export default class SettingsAppointment extends Component{
    state = {};

    handleAppTypeEdit = (appType)=>{
        this.setState({appType:new AppointmentType(appType)});
    }

    handleCancel = ()=>{
        this.setState({appType:null})
    }

    handleUpdate = ()=>{
        this.forceUpdate();
    }

    render(){
        let editCaption = <span><b>Add</b> Custom Category</span>;
        if(this.state.appType){
            let app = new AppointmentType(this.state.appType);
            let appClass = app.categoryName? 'Base':'Custom';
            editCaption = <span><b>Edit</b> {appClass} Category - {app.name}</span>;

        }
        return (
            <div>
                <div className={SanitizeClassNames(this, 'settings-appointments table hmax align-top')}>
                    <div>
                        <div className='app-categories'>
                            <div>
                                <h1>Base Categories</h1>
                                <AppList clinicId={this.props.clinicId} onEdit={this.handleAppTypeEdit} type='category' selected={this.state.appType} />
                                <h1>Custom Categories</h1>
                                <AppList clinicId={this.props.clinicId} onEdit={this.handleAppTypeEdit} type='type' selected={this.state.appType} />
                            </div>
                        </div>
                        <div className='app-editor'>
                            <h1>{editCaption}</h1>
                            <AppTypeEditor appType={this.state.appType} onCancel={this.handleCancel} onUpdate={this.handleUpdate} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

class AppList extends Component{
    state = {list:[]}

    sortList(l){
        l.sort((a, b) => {
            if(a.name === b.name)return 0;
            return (a.name < b.name)? -1:1;
        });
    }

    handleEditType = (appType)=>{
        if(this.props.onEdit){
            this.props.onEdit(appType);
        }
    }

    getList(){
        switch(this.props.type){
            case 'type':
                return AppointmentTypeService.GetAppTypes();
            break;
            case 'category':
                return AppointmentTypeService.GetCategoryCache().getAll();
            break;
        }

        return [];
    }

    getId(itm){
        if(itm){
            if(itm.categoryName){
                return itm.appointmentCategoryId;
            }
            return itm.appointmentTypeId;
        }
    }

    updateList(){
        let items = this.getList().filter((item)=>{
            return item.statusCode === 'ACTV';
        });

        this.sortList(items);
        let list = [];
        let selectedId = this.getId(this.props.selected);
        for(let i in items){
            let itm = new AppointmentType(items[i]);
            let isSelected = (this.getId(itm) == selectedId)? ' selected':'';
            list.push(
                <div className={'item table align-middle' + isSelected} onClick={()=>this.handleEditType(itm)}>
                    <div>
                        <div><div className='app-color' style={ {backgroundColor: '#' + (itm.color || '').replace('#', '') } }></div></div>
                        <div className='app-name'>{itm.name}<br />{itm.duration}m</div>
                        <div><img src={editIcon} /></div>
                    </div>


                </div>
            );
        }

        return list;
    }

    /*componentDidMount(){
        this.updateList();
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.clinicId !== this.props.clinicId){
            this.updateList();
        }
    }*/

    render(){

        return(
            <div className='app-list'>
                {this.updateList()}
            </div>
        )
    }
}

class AppTypeEditor extends Component{
    form = new FormDataObj();
    state = {errors:{}};
    handleClick = ()=>{
        console.log('App Form:', this.form.data);

        if(!this.state.busy){
            let errors = this.form.getErrorState();
            this.setState({errors: errors});
            console.log("Form Errors:", errors);
            if(errors != null){
                return;
            }
            this.setState({busy:true});
            if(this.form.data.categoryName){
                AppointmentTypeService.CreateCat(this.form.data).then(() =>{
                    this.updateComplete();
                })
            }else{
                AppointmentTypeService.CreateType(this.form.data).then(() =>{
                    this.updateComplete();
                })
            }

        }

    }

    updateComplete(){
        this.setState({busy:false});
        if(this.props.onUpdate){
            this.props.onUpdate();
        }
    }


    handleColorChange = (color) =>{
        this.form.data.color = color.hex.replace('#', '');
        //this.form.populateFormItems();
        this.forceUpdate();
    }

    handleCancel = ()=>{
        this.form.data = {
            color: '000000'
        };
        this.form.populateFormItems();
        if(this.props.onCancel){
            this.props.onCancel();
        }
    }

    handleDelete = ()=>{
        let appType = this.props.appType;
        appType.statusCode = 'DLTD';
        this.setState({busy:true});
        AppointmentTypeService.CreateType(appType).then(()=>{
            this.updateComplete();
        })
    }


    render(){
        let errors = this.state.errors || {};
        let appTypeName = 'name';

        let canEdit = true;
        if(this.props.appType){
            this.form.data = this.props.appType;
            if(this.props.appType.categoryName){
                appTypeName = 'categoryName'
            }
            this.form.populateFormItems();
            //colorStyle.backgroundColor = '#' + this.props.appType.color;
            const appType = this.props.appType;
            canEdit = !appType.appointmentSourceCd || appType.appointmentSourceCd === 'BIOPED'

        }

        let colorStyle = {
            backgroundColor: '#' + (this.form.data.color || '000')
        }


        let caption = 'Add Custom Category';
        let btnClass = 'black';
        let showCancel = false;
        let canDelete = !(this.props.appType && this.props.appType.categoryName);


        if(this.props.appType && this.props.appType.appointmentTypeId){
            caption = 'save';
            btnClass = 'green';
            showCancel = true;
        }

        if(this.props.appType && this.props.appType.categoryName){
            caption = 'save';
            btnClass = 'green';
            showCancel = true;
        }

        if(!this.form.data.color) {
            this.form.data.color = '000';
        }

        return(
            <div className='app-type-editor'>
                <SwatchesPicker className='app-color-picker' color={'#' + this.form.data.color} onChangeComplete={this.handleColorChange} width='auto' height='161px' overflow-y='auto'/>
                <div className='table hmax align-top'>
                    <div>
                        <div>
                            <FormLabeledItem label='Category Name'>
                                <Input placeholder='Category Name' name='name'  form={this.form} error={errors['name']} required />
                            </FormLabeledItem>
                        </div>
                        <div>
                            <FormLabeledItem label='Duration'><TimeStepper className='hmax' name='duration'  form={this.form} incr='5' min={0} max={60} /></FormLabeledItem>
                        </div>
                    </div>
                    <div>
                        <div>
                            <FormLabeledItem label='Base Category'>
                                <AppointmentCategoryList name='appointmentCategoryId' form={this.form} disabled={(this.props.appType && this.props.appType.categoryName)} error={errors['appointmentCategoryId']} required />
                            </FormLabeledItem>
                        </div>
                        <div>
                            <FormLabeledItem label='Color'>
                                <div className='color' style={colorStyle}></div>
                            </FormLabeledItem>
                        </div>
                    </div>
                    <div>
                        <div></div>
                        {canEdit? <div>
                            <Button className={btnClass} caption={caption} onClick={this.handleClick} isBusy={this.state.busy} />&nbsp;&nbsp;
                            {(showCancel && !this.state.busy) ? <Button caption='Cancel' onClick={this.handleCancel} />:null}
                            {canDelete && !this.state.busy? <Button caption="Delete" className='apptype-delete-btn red' onClick={this.handleDelete} />:null}
                        </div>: null}
                    </div>

                </div>
            </div>
        )
    }
}

/*class TimeStepper extends FormItemBase{

    increment = ()=>{
        this._onValueChanged(this.value + this.incr);
    }

    decrement = ()=>{
        this._onValueChanged(this.value - this.incr);
    }

    get value(){
        return Number(isNaN(this.state.value)? 0:this.state.value);
    }

    get incr(){
        return Number(isNaN(this.props.incr)? 1:this.props.incr);
    }


    render(){
        return(
            <div className={SanitizeClassNames(this, 'time-stepper table align-middle align-center')}>
                <div>
                    <div onClick={this.increment}><Icon icon='arrow' className='arrow up'  /></div>
                    <div>{this.value} (m)</div>
                    <div onClick={this.decrement}><Icon icon='arrow' className='arrow down'  /></div>
                </div>
            </div>
        )
    }
}
*/



// WEBPACK FOOTER //
// ./src/views/Settings/SettingsAppointment.js